/**
 * 廣告配置文件
 * 集中管理所有廣告單元的配置
 */

export const AD_CLIENT = 'ca-pub-4962994846652942';

// 真實廣告單元 ID (由用戶提供)
export const AD_SLOTS = {
  // Omakase-Responsive-Main (用於首頁、列表頁頂部)
  RESPONSIVE_MAIN: '1606186829',
  
  // Omakase-InArticle-Fluid (用於文章內容中間)
  IN_ARTICLE_FLUID: '7980023487',
  
  // Omakase-Footer-Banner (用於頁腳、側邊欄、文章底部)
  FOOTER_BANNER: '2975819251',
};

// 廣告尺寸配置
export const AD_SIZES = {
  LEADERBOARD: { width: 728, height: 90 },      // 橫幅廣告
  RECTANGLE: { width: 336, height: 280 },       // 內文廣告
  HALF_PAGE: { width: 300, height: 600 },       // 側邊欄廣告
  MOBILE_BANNER: { width: 320, height: 100 },   // 手機橫幅
};

// 廣告位置配置
export const AD_POSITIONS = {
  // 首頁廣告配置
  HOME: {
    banner1: {
      slot: AD_SLOTS.RESPONSIVE_MAIN,
      format: 'auto',
      responsive: true,
      className: 'my-12',
      label: '首頁頂部橫幅'
    },
    banner2: {
      slot: AD_SLOTS.RESPONSIVE_MAIN,
      format: 'auto',
      responsive: true,
      className: 'my-12',
      label: '首頁中部橫幅'
    },
  },
  
  // 文章列表頁廣告配置
  ARTICLE_LIST: {
    top: {
      slot: AD_SLOTS.RESPONSIVE_MAIN,
      format: 'auto',
      responsive: true,
      className: 'my-8',
      label: '列表頁頂部廣告'
    },
    middle: {
      slot: AD_SLOTS.RESPONSIVE_MAIN,
      format: 'auto',
      responsive: true,
      className: 'my-8',
      label: '列表頁中部廣告'
    },
  },
  
  // 文章詳情頁廣告配置
  ARTICLE: {
    top: {
      slot: AD_SLOTS.RESPONSIVE_MAIN,
      format: 'auto',
      responsive: true,
      className: 'my-8',
      label: '文章標題下廣告'
    },
    sidebar: {
      slot: AD_SLOTS.FOOTER_BANNER,
      format: 'vertical', // 側邊欄適合垂直廣告
      responsive: true,
      className: 'sticky top-24',
      style: { minHeight: '600px' },
      label: '側邊欄廣告'
    },
    middle: {
      slot: AD_SLOTS.IN_ARTICLE_FLUID,
      format: 'fluid',
      layout: 'in-article', // 文章內嵌專用佈局
      responsive: true,
      className: 'my-8',
      label: '文章內嵌廣告'
    },
    bottom: {
      slot: AD_SLOTS.FOOTER_BANNER,
      format: 'auto',
      responsive: true,
      className: 'my-8',
      label: '文章底部廣告'
    },
  },
};

export default {
  AD_CLIENT,
  AD_SLOTS,
  AD_SIZES,
  AD_POSITIONS,
};